import React from 'react';
import DashboardLayout from './DashboardLayout';

export default function DashboardUser(props: any) {
  return <DashboardLayout {...props} />
}
